<template>
  <tr v-if="style_list === 'table'" :class="{ blocked: user.status === 'blocked' }">
    <td>
      <div class="main">
        <UserPhoto v-if="user.photo" :size="30" :img="user.photo" />
        <v-avatar v-else color="#277FAF" size="30">
          <span class="text-uppercase white--text">
            {{ user.first_name.slice(0, 1) + user.last_name.slice(0, 1) }}
          </span>
        </v-avatar>
        <span>
          {{ user.first_name + ' ' + user.last_name }}
        </span>
        <ButtonCopy :text="user.first_name + ' ' + user.last_name" height="100%" />
      </div>
    </td>
    <td>
      <BaseLink :text="user.email" type="mail" copy />
    </td>
    <td>
      <BaseLink
        v-if="user.phone !== null && user.phone[0] !== null"
        :text="user.phone[0]"
        type="tel"
        copy
      />
      <span v-else>-</span>
    </td>
    <td>
      <div class="d-flex flex-wrap">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
              <IconsUsersStatus :status="user.status" />
            </div>
          </template>
          <span>{{
              user.status === 'authorized'
                ? localStorage.translations.pages['setting-users'].status.authorized
                : user.status === 'invited' || user.status === 'not_completed'
                  ? localStorage.translations.pages['setting-users'].status.invited
                  : user.status === 'blocked'
                    ? localStorage.translations.pages['setting-users'].status.blocked
                    : user.status === 'restore'
                      ? localStorage.translations.pages['setting-users'].status.restore
                      : '-'
            }}</span>
        </v-tooltip>
      </div>
    </td>
    <td>
      <div class="d-flex flex-wrap">
        <v-tooltip v-if="userAgentData" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
              <v-card class="visit f12" flat :color="quarter === 1 ? 'transparent' : quarter === 3 ? '#525252' : '#bfbfbf'" :dark="quarter === 3">
                {{ user.last_request ? $formatDate(user.last_request) : '-' }}
                <IconDevices :type="userAgentData.os.name" />
              </v-card>
            </div>
          </template>
          <span>{{ userAgentData.ua }}</span>
          <div>
            <div v-if="userAgentData.os.name">
              OS:
              {{
                userAgentData.os.name +
                ' ' +
                (userAgentData.os.version ? userAgentData.os.version : '')
              }}
            </div>
            <div v-if="userAgentData.browser.name && userAgentData.browser.version">
              Browser:
              {{ userAgentData.browser.name + ' ' + userAgentData.browser.version }}
            </div>
            <div v-if="userAgentData.app && userAgentData.app.name && userAgentData.app.version">
              App:
              {{ userAgentData.app.name + ' ' + userAgentData.app.version }}
            </div>
            <div v-if="userAgentData.device.vendor && userAgentData.device.model">
              Device: {{ userAgentData.device.vendor + ' ' + userAgentData.device.model }}
            </div>
          </div>
        </v-tooltip>
        <template v-else> - </template>
      </div>
    </td>
    <td>
      <span
        class="role f12"
        :style="{
          backgroundColor: roleInfo.back_color,
          color: roleInfo.text_color,
        }"
        >{{
          roleInfo !== ''
            ? roleInfo.role_name
            : localStorage.translations.pages.common.text.not_assigned
        }}</span
      >
    </td>
    <td>
      <div class="icons">
        <UserProjectsModal
          v-if="subscriber"
          :onDownloadPageData="onDownloadPageData"
          :projects="user.projects_subscriptions"
        />
        <EmployeeIcon v-else class="employee" :class="{ active: user.employee }" />
      </div>
    </td>
    <td>
      <div class="icons">
        <UserOfferAgreementHistoryModal :user="user" />
      </div>
    </td>
    <td>
      <div class="buttons">
        <UserTableEdit
          v-if="
            $userCheckAccess({
              abilities: 'edit_users',
            })
          "
          :id="user.id"
          :onDownloadPageData="onDownloadPageData"
          :subscriber="subscriber"
        />
        <DeleteModal
          v-if="
            $userCheckAccess({
              abilities: 'remove_users',
            })
          "
          ref="deleteModal"
          :text="
            localStorage.translations.pages['setting-users']['dialog-delete'][
              'udalit-polzovatelya'
            ] +
            ' ' +
            user.first_name +
            ' ' +
            user.last_name
          "
          :textSecond="
            localStorage.translations.pages['setting-users']['dialog-delete'][
              'udalit-polzovatelya'
            ] +
            ' ' +
            user.first_name +
            ' ' +
            user.last_name
          "
          :textCheckbox="localStorage.translations.pages.common.checkbox.delete_all_links"
          :methodDelete="onDeleteUser.bind(null, user.id)"
          :methodDeleteConfirm="onDeleteUserConfirm.bind(null, user.id)"
        />
      </div>
    </td>
  </tr>
  <div
    v-else-if="style_list === 'grid'"
    class="card"
    :class="{ blocked: user.status === 'blocked' }"
  >
    <div class="card__top">
      <div class="card__top__icons">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="icon" v-on="on" v-bind="attrs">
              <IconsUsersStatus :status="user.status" />
            </div>
          </template>
          <span>{{
            user.status === 'authorized'
              ? localStorage.translations.pages['setting-users'].status.authorized
              : user.status === 'invited' || user.status === 'not_completed'
              ? localStorage.translations.pages['setting-users'].status.invited
              : user.status === 'blocked'
              ? localStorage.translations.pages['setting-users'].status.blocked
              : user.status === 'restore'
              ? localStorage.translations.pages['setting-users'].status.restore
              : '-'
          }}</span>
        </v-tooltip>
        <EmployeeIcon class="employee" :class="{ active: user.employee }" />
        <UserOfferAgreementHistoryModal :user="user" />
      </div>
      <div class="card__top__image">
        <UserPhoto :size="98" :img="user.photo" />
      </div>
      <div class="card__top__buttons">
        <DeleteModal
          v-if="
            $userCheckAccess({
              abilities: 'remove_users',
            })
          "
          ref="deleteModal"
          :text="
            localStorage.translations.pages['setting-users']['dialog-delete'][
              'udalit-polzovatelya'
            ] +
            ' ' +
            user.first_name +
            ' ' +
            user.last_name
          "
          :textSecond="
            localStorage.translations.pages['setting-users']['dialog-delete'][
              'udalit-polzovatelya'
            ] +
            ' ' +
            user.first_name +
            ' ' +
            user.last_name
          "
          :textCheckbox="localStorage.translations.pages.common.checkbox.delete_all_links"
          :methodDelete="onDeleteUser.bind(null, user.id)"
          :methodDeleteConfirm="onDeleteUserConfirm.bind(null, user.id)"
        />
        <UserTableEdit
          v-if="
            $userCheckAccess({
              abilities: 'edit_users',
            })
          "
          :id="user.id"
          :onDownloadPageData="onDownloadPageData"
          :subscriber="subscriber"
        />
      </div>
    </div>
    <div class="card__bot">
      <p class="name f18">{{ user.first_name + ' ' + user.last_name }}</p>
      <p class="email f14">{{ user.email }}</p>
      <p class="email f14">{{ user.phone !== null ? user.phone[0] : '-' }}</p>
      <span
        class="role f12"
        :style="{
          backgroundColor: roleInfo.back_color,
          color: roleInfo.text_color,
        }"
        >{{
          roleInfo !== ''
            ? roleInfo.role_name
            : localStorage.translations.pages.common.text.not_assigned
        }}</span
      >
    </div>
  </div>
</template>

<script>
import UserPhoto from 'components/setting/users/UserPhoto'
import IconsUsersStatus from 'components/icons/users/IconsUsersStatus'
import IconDevices from 'components/icons/IconDevices'
import UserTableEdit from 'components/setting/users/UserTableEdit'
import DeleteModal from 'components/DeleteModal'
import EmployeeIcon from 'components/icons/employees/Employee'
import UserOfferAgreementHistoryModal from 'components/setting/users/UserOfferAgreementHistoryModal'
import ButtonCopy from 'components/ButtonCopy'
import BaseLink from 'components/base/BaseLink'
import UserProjectsModal from 'components/setting/users/UserProjectsModal'

export default {
  name: 'UsersListItem',
  components: {
    BaseLink,
    ButtonCopy,
    UserPhoto,
    DeleteModal,
    UserTableEdit,
    EmployeeIcon,
    UserOfferAgreementHistoryModal,
    IconsUsersStatus,
    IconDevices,
    UserProjectsModal,
  },
  props: {
    user: Object,
    style_list: {
      type: String,
      default: 'table',
    },
    onDownloadPageData: Function,
    subscriber: Boolean,
  },
  data: () => ({
    dialog: false,
    search: '',
  }),
  computed: {
    roleInfo() {
      return this.user.roles[0] || ''
    },
    userAgentData() {
      if (this.user.last_user_agent) {
        if (this.user.last_user_agent.indexOf('ProApp') !== -1) {
          let result = {
            ua: this.user.last_user_agent,
            os: {},
            app: {},
            device: {},
            browser: {},
          }
          let [app, data] = this.user.last_user_agent.split(/(?!\(.*)\s(?![^(]*?\))/g)
          data = data.replace(/[()]/g, '')
          result.app.name = app.split('/')[0]
          result.app.version = app.split('/')[1]
          result.os.name = data.split('; ')[2].split(' ')[0]
          result.os.version = data.split('; ')[2].split(' ')[1]
          return result
        } else return this.userAgentParser(this.user.last_user_agent)
      } else return null
    },
    quarter() {
      let v = new Date(this.user['last_request'])
      let n = new Date()
      let days = (n - v) / (1000 * 3600 * 24)
      return days > 90 ? 3 : days < 30 ? 1 : 2
    }
  },
  methods: {
    userAgentParser(ua) {
      var parser = require('ua-parser-js')
      return parser(ua)
    },
    onDeleteUser(id) {
      this.$store
        .dispatch('commonUser/onCommonUserDelete', id)
        .then(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },

            { root: true },
          )
          this.onDownloadPageData()
          this.$refs.deleteModal.closeModal()
        })
        .catch((err) => {
          if (err.response && err.response.data.message == 'User has employee docs.') {
            this.$refs.deleteModal.stage = 2
          } else {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'] + '\n' + err.response.data.message,
                IsError: true,
              },
              { root: true },
            )
            this.$refs.deleteModal.closeModal()
          }
        })
    },
    onDeleteUserConfirm(id) {
      this.$store
        .dispatch('commonUser/onCommonUserDeleteConfirm', id)
        .then((response) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },

            { root: true },
          )
          this.onDownloadPageData()
          this.$refs.deleteModal.closeModal()
        })
        .catch((err) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
          this.$refs.deleteModal.closeModal()
        })
    },
  },
}
</script>

<style lang="scss" scoped>
tr {
  &.blocked {
    background-color: #dbdbdb;
  }
}
td {
  .main {
    min-height: 44px;
    display: grid;
    grid-template-columns: auto 1fr auto;
    column-gap: 10px;
    align-items: center;
  }
}
:deep().employee {
  path {
    fill: #878787;
  }
  &.active {
    path {
      fill: #f2a127;
    }
  }
}
.visit {
  border-radius: 9px !important;
  padding: 4px 8px !important;
  gap: 5px;
  display: flex;
  align-items: center;
}
:deep() .role {
  display: block;
  padding: 8px;
  border-radius: 9px;
  color: #ffffff;
  width: max-content;
  line-height: 1;
  background-color: #828282;
}
.card {
  background: #f2f2f2;
  border: 1px solid #d1d1d1;
  border-radius: 4px;
  text-align: center;
  display: grid;
  grid-template-rows: 1fr;
  justify-items: center;
  text-decoration: none;
  transition: 0.3s;
  &.blocked {
    background-color: #dbdbdb;
  }
  &:hover {
    box-shadow: 0px 4px 8px rgba(151, 151, 151, 0.25);
    background: #ffffff;
  }
  &__top {
    display: grid;
    grid-template-columns: max-content max-content 50px;
    justify-content: space-between;
    column-gap: 25px;
    width: 100%;
    &__icons {
      display: grid;
      padding: 20px;
      row-gap: 16px;
      .icon {
        width: max-content;
        height: max-content;
        line-height: 0;
      }
    }
    &__image {
      padding-top: 30px;
    }
    &__buttons:deep() {
      display: grid;
      grid-template-rows: max-content max-content;
      .editBtn,
      .delete_button {
        height: 50px;
        width: 50px;
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          right: 10px;
          top: 10px;
          margin-bottom: 10px;
        }
      }
    }
  }
  &__bot {
    display: grid;
    row-gap: 10px;
    padding: 0 10px 30px;
    justify-content: center;
    justify-items: center;
    p {
      margin: 0;
    }
  }
}

</style>
